import { loadMasking } from '@glu/core';

loadMasking();
